import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementOrganicFertilizerEmissionFactors } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_ORGANIC_FERTILIZER_EMISSION_FACTORS } from "consts";

export const usePracticeManagementOrganicFertilizerEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_ORGANIC_FERTILIZER_EMISSION_FACTORS, country, version],
    queryFn: async () => {
      const factors = await getPracticeManagementOrganicFertilizerEmissionFactors(version, country);
      return factors.map((factor) => ({
        ...factor,
        editingKey: factor.fertilizerId,
      }));
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24,
  });
